import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {InteractionListItemComponent} from './interaction-list-item.component';
import { CustomIconsModule } from 'src/app/theme/shared/components/custom-icons/custom-icons.module';



@NgModule({
  declarations: [InteractionListItemComponent],
  imports: [
    CommonModule,
    CustomIconsModule
  ],
  exports: [InteractionListItemComponent]
})
export class InteractionListItemModule { }
